import * as React from "react";
const IconDelete = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.98645 7.99243V17.9924C5.98645 20.2016 7.77731 21.9924 9.98645 21.9924H15.9865C18.1956 21.9924 19.9865 20.2016 19.9865 17.9924V7.99243M14.9865 10.9924V16.9924M10.9865 10.9924L10.9865 16.9924M16.9865 4.99243L15.5802 2.88303C15.2093 2.32663 14.5848 1.99243 13.9161 1.99243H12.0568C11.3881 1.99243 10.7636 2.32663 10.3927 2.88303L8.98645 4.99243M16.9865 4.99243H8.98645M16.9865 4.99243H21.9865M8.98645 4.99243H3.98645"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconDelete;
